<template>
  <div>
    <div class="intro-y flex items-center h-10">
      <h2 class="text-lg font-medium truncate mr-5">{{ $t('dashboard.lendingByGender') }}</h2>
    </div>
    <div class="intro-y box p-5 mt-5">
      <DashboardLendingByPieChart :list="chartData" :height="210" />
      <div class="mt-2">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="['flex items-center', { 'mt-4': index > 0 }]"
        >
          <div :class="['w-2 h-2 rounded-full mr-3', item.color]"></div>
          <span class="truncate">{{ item.name }}</span>
          <div
            class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"
          ></div>
          <span class="font-medium xl:ml-auto">{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardLendingByPieChart from '@/components/dashboard/DashboardLendingByPieChart';

export default {
  props: {
    report: Object,
  },

  components: {
    DashboardLendingByPieChart,
  },

  computed: {
    chartData() {
      return {
        labels: this.list.map(item => item.name),
        data: this.list.map(item => item.value),
      };
    },
    list() {
      if (this.report.loan?.byGender) {
        return [
          {
            name: this.$t('dashboard.female'),
            value: this.report.loan.byGender.female,
            color: 'bg-theme-9',
          },
          {
            name: this.$t('dashboard.male'),
            value: this.report.loan.byGender.male,
            color: 'bg-theme-1',
          },
        ];
      }

      return [];
    },
  },
};
</script>
